import { Form, Formik } from 'formik';
import { useContext, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';
import CustomTabMenu from '../../../../component/CustomTabMenu';
import { KEY_DS_TAB_TIEP_DON, MESSAGE } from '../../../../utils/Constant';
import InfoPatientRight from '../../../components/InfoPatientRight';
import { PhanHeTiepDonContext } from '../../../contexts/PhanHeTiepDonContext';
import PhieuKhamChuyenKhoa from './components/PhieuKhamChuyenKhoa';
import ThongTinChung from './components/ThongTinChung';
import * as Yup from 'yup';

type Props = {
	open: boolean;
	handleCloseModal: () => void;
	handleSubmit: (values: any) => void;
	modalityDetails?: any;
};

const ModalNhapVien = ({ open, handleCloseModal, handleSubmit, modalityDetails }: Props) => {
	const { benhNhanInfo } = useContext(PhanHeTiepDonContext);

	const [activeTab, setActiveTab] = useState('1');

	const validationSchema = Yup.object().shape({
		treatmentDept: Yup.object().nullable().required(MESSAGE.REQUIRED),
	});

	const onSubmit = (values: any) => {
		const submitData = {
			treatmentReason: values?.treatmentReason,
			treatmentDeptCode: values?.treatmentDept?.code,
			treatmentDeptName: values?.treatmentDept?.name,
			treatmentDeptId: values?.treatmentDept?.id,
			mauPhieuKhamBenh: values.template?.code,
			...(values?.template
				? {
						[values.template.code]: values?.form,
				  }
				: null),
		};

		handleSubmit({
			...modalityDetails,
			...submitData,
		});
	};

	return (
		<Modal show={open} centered size="lg" onHide={handleCloseModal} scrollable>
			<ModalHeader closeButton>
				<Modal.Title>Nhập viện</Modal.Title>
			</ModalHeader>

			<Formik<any>
				initialValues={{
					treatmentDept: null,
					treatmentReason: '',
					template: null,
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
			>
				{({ values }) => (
					<Form className="d-flex flex-column overflow-hidden">
						<ModalBody className='min-h-250px'>
							<InfoPatientRight benhNhanInfo={benhNhanInfo} />

							<CustomTabMenu
								danhsachTabs={[
									{
										eventKey: '1',
										title: 'Thông tin chung',
										component: <ThongTinChung />,
									},
									...(values?.template
										? [
												{
													eventKey: '2',
													title: 'Phiếu khám chuyên khoa',
													component: <PhieuKhamChuyenKhoa />,
												},
										  ]
										: []),
								]}
								keyDanhSachTabs={KEY_DS_TAB_TIEP_DON}
								childrenTab
								activeTab={activeTab}
								onTabChange={(activeTab: any) => setActiveTab(activeTab)}
							/>
						</ModalBody>

						<ModalFooter className="d-flex justify-content-end py-2">
							<Button className="btn-fill btn-danger" onClick={handleCloseModal}>
								Đóng
							</Button>
							<Button className="btn-fill" type="submit">
								Lưu
							</Button>
						</ModalFooter>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export default ModalNhapVien;
